import { useMutationWithInvalidation } from '@/shared/composables/useMutationWithInvalidation'
import { type MaybeRefOrGetter, toValue } from 'vue'
import { removeUploadedFile } from '@/shared/api/uploads/removeUploadedFile'
import { UploadedFileQueries } from '@/shared/queries'

export const useFileUploadRemoval = () => useMutationWithInvalidation(
  (id: MaybeRefOrGetter<string>) => removeUploadedFile(toValue(id)),
  [(id) => UploadedFileQueries.fetch(id).queryKey]
)
